import MessageCard from '../MessageCard';
import '../Styles/Posts.css';
import { COLOR, IMAGE, URL, Usernames } from '../../utils/source-constants';
import { Post, Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';
import { Platform } from '../../post-interface';

const defaultSourceRenderer = (source: Source) => (
    <div className='name'>
        <h3>{source.username}</h3>
    </div>
);

export function Posts({
    source,
    posts,
    withUsernames,
    shouldHighlight,
    shouldLink,
    renderSource = defaultSourceRenderer,
}: {
    source: Source;
    posts?: Post[];
    withUsernames?: boolean;
    renderSource?: (source: Source, sourceDetails: SourceDetails) => JSX.Element;
    shouldHighlight?: (post: Post) => boolean;
    shouldLink?: (post: Post) => boolean;
}) {
    return (
        <section>
            <div className='container-form'>
                <div className={`feed-source ${source.username}`}>{renderSource(source, getSourceDetails(source))}</div>
                <div>
                    {posts ? (
                        posts.map((post) => {
                            const { color, image } = getSourceDetails(post);
                            const linked = shouldLink?.(post);
                            const highlighted = shouldHighlight?.(post);

                            const gradients = getComputedStyle(document.body);
                            const currentGradient = gradients.getPropertyValue(linked ? COLOR[Platform.Twitter][Usernames.PumpFun] : color);

                            return (
                                <MessageCard
                                    key={post.id}
                                    post={post}
                                    background={currentGradient}
                                    platform={post.platform}
                                    highlighted={highlighted}
                                    linked={linked}
                                    username={withUsernames ? post.username : undefined}
                                    icon={withUsernames ? `data:image/jpeg;base64,${image}` : undefined}
                                />
                            );
                        })
                    ) : (
                        <div className='load'>Loading...</div>
                    )}
                </div>
            </div>
        </section>
    );
}

export type SourceDetails = ReturnType<typeof getSourceDetails>;

function getSourceDetails(source: Source) {
    const getDetails = <T extends Record<string, any>>(base: Record<string, T>, platform: string) => {
        return base[platform] && (base[platform][source.username as keyof T] as string);
    };

    const color = getDetails(COLOR, source.platform);
    const image = getDetails(IMAGE, source.platform);
    const url = getDetails(URL, source.platform);

    return { color, image, url };
}
